export const questions = [
  {
    id: 1,
    question: "What are your safety practices due to Covid-19?",
    // WHAT ARE YOUR SAFETY PRACTICES DUE TO COVID-19
    answer:
      "The health and safety of our customers and photographers is our highest priority Pre-shoot, your photographer will Monitor and confirm that outdoor shoots are currently allowed in their city Recommend a better location if your preferred route is too crowded or not safe.Reach out a few days before your shoot date to confirm everyone is still healthy.During the shoot ,Photographers will remain at least 6 feet away at all times.Although they miss the hugs and handshakes,air high fives and heart-hands are always welcome !",
  },
  {
    id: 2,
    question: "How long in advance should i book my shoot?",
    // HOW LONG IN ADVANCE SHOULD I BOOK MY SHOOT
    answer:
      "We suggest you book at least a week in advance, although we will attempt to accommodate last-minute requests (but no promises). The ideal time frame to ensure you get YOUR preferred time/date is at least 4 weeks in advance.",
  },

  {
    id: 3,
    question: "How many people can book a photo session together?",
    answer:
      " To get beautiful shots with a group, you'll need a lot of time on the session. To do so, we've created various packages depending upon the number of people in a group. The below are our group limits set:1 Hour: group of 3 maximum2 Hours: group of 5 maximum3 Hours: group of 7 maximum*If more participants show up to your shoot than you previously indicated on your booking form, and the total number of persons then exceed the package requirement, additional people above the limit will be charged INR 500 per head. The duration of the package and the number of photographs included in it will stay the same as they were when you booked it.",
  },
  {
    id: 4,
    question: "Will you publish my pictures on the internet?",
    answer:
      "Yes, we reserve the right to do so. But if you don't want us to publish your pictures on the internet then you must inform us through email or a call at the time of booking.",
  },
  {
    id: 5,
    question: "What if I need to postpone or cancel my booking?",
    answer:
      "For detailed information kindly check our Cancellation and Rescheduling Policy.",
  },

  {
    id: 6,
    question: "Can I change my destination after I've made a booking?",
    answer:
      "Yes, most of the time, but sometimes photographers have scheduled the rest of their day around the spot you've already selected, and it might not be possible to change it. This is particularly true when it comes to last minute adjustments. We will always do our best to accomodate you, but please keep in mind that once a route has been selected, we would not be able to change it due to some unexpected circumstances.",
  },
  {
    id: 7,
    question: "What happens if I'm late?",
    answer:
      "If you are running late, please text or email your photographer. If you show up late, remember that the photographer could have another session scheduled soon after yours, and it is doubtful that you'll be able to extend your session, even though it's always possible so please consider asking first! We recommend that you arrive early, or perhaps eat/drink something nearby so that it is not a rush situation for you to begin your photoshoot. Keep in mind that traffic in major cities can be uncertain. ",
  },

  {
    id: 8,
    question:
      "Can I extend the session time if the photographer is free or available? ",
    answer:
      "If you show up late for your shoot, any time which has passed since your originally scheduled time , will be lost, and you will only be able to shoot for the remaining time you have scheduled. If the photographer is available, you may request more time. However, additional time is charged at a cost of INR 500 for every 30 minutes. If you would like your photographer to wait for you longer than the end time of your session, the extended waiting time will be charged as INR 250 for every 15 minutes, in addition to any charges charged in relation of the photoshoot extension.",
  },
  {
    id: 9,
    question: "What happens if it rains?",
    answer:
      "All of our photographers are okay with shooting in light rains but we will directly connect you with your assigned photographer so that you can discuss as per your preferences. We DO NOT guarantee the availability of the photographer, but we will try our best to reschedule your booking on heavy raining days. We offer a full refund in case of bad weather or any natural circumstances that lead to cancellation of your shoot and it is impossible to reschedule it again.",
  },
  {
    id: 10,
    question: "Can I buy more time while a session is in progress?",
    answer:
      "Sure, why not? If you want to continue and your photographer is available, you can pay the extra charges online/offline. Every 30 minutes cost additional INR 500 charges.",
  },

  {
    id: 11,
    question:
      "I am impressed and satisfied by the pictures my photographer clicked. Is it okay to tip them after the shoot?",
    answer:
      "We are glad you asked this question. Our photographers are adequately paid for the efforts they put in the shoots, so tips are not expected at all. Some of our clients enjoy their photographer's company so much that they go out for coffee or tea after completing their shoot. But it is not expected from any client, you have complete control of it!",
  },

  {
    id: 12,
    question: "When will I be able to see/get my photos?",
    answer: "",
  },
  {
    id: 13,
    question: "In what format will my photos be delivered to me?",
    answer:
      "Your photos will be delivered through online gallery, along with the high resolution photos, all in the JPEG format.",
  },
  {
    id: 14,
    question: "Do I have the ownership of my photographs?",
    answer:
      "You have full authorization to use the photos for personal usage. Print, share, hang them on your walls or do whatever you would like with your photographs. We'd love to include your pictures in our online portfolio, but if you're socially awkward and prefer to keep them private, please do let us know, so we'll never publish them anywhere publicly. The copyright remains with the company.",
  },

  {
    id: 15,
    question:
      " Is it possible for me to buy all the photographs taken by the photographer?",
    answer:
      "Unfortunately, it is not possible. We understand that getting the perfect version of a shot can take dozens of clicks, and because our photographers shoot in RAW format, this would actually involve editing hundreds of extra less-than-ideal shots rather than focusing on delivering you the best of the bunch. This leads to our second, more important reason: we only want to send you photos that we believe you will enjoy.",
  },
  {
    id: 16,
    question: "Does my package include any photo editing services?",
    answer:
      "Yes,With outdoor lighting, our style is typically candid and natural. Basic editing, such as colour balance, adjustments and cropping will be provided by the company editors. ",
  },
  {
    id: 17,
    question: "Is it possible to hire Fodrixographer for a commercial project?",
    answer:
      "Yes ofcourse, please do send us the details of your project and any questions related to the commercial shoots. After that, we'll send you more details on commercial pricing.",
  },

  {
    id: 18,
    question: "Can I hire a Fodrixographer for a wedding?",
    answer:
      "Yes, you can absolutely book a photographer for a wedding via Fodrix! We will be honoured to join you on such special day to capture all the special moments. We also offer other various types of photoshoots along with wedding photography.",
  },
  {
    id: 19,
    question: "Is event pricing same as travel photography shoot?",
    answer:
      "Pricing varies depending on the event/occasion, length and location. Contact us for more details to support@fodrix.com",
  },
  {
    id: 20,
    question:
      "What are my options if you don't offer photographers in my desired destinations?",
    answer: "Contact us or directly email to support@fodrix.com",
  },
  {
    id: 21,
    question:
      "Do I have to pay any additional charges once I book a photoshoot?",
    answer:
      "No. But please, have in mind that you are responsible for any admission fees or transportation fees during the photoshoot (entry to the museum, booking a cab, public transportation, etc.).",
  },
];
